import {RouteEntry} from "../../shared/routes";
import {Messages} from "./Messages";

export const myMessagesRoutes: Array<RouteEntry> = [
    { path: '/messages/:id', component: Messages },
    { path: '/messages/', component: Messages },
];
